import React from "react";
import { Link } from "react-router-dom";

const ExamesListar = ({ exames }) => {
    const ano = new Date().getFullYear();
    const basePath = "/exame";

    return (
      <div className="container">
        <section className="no-bg">
          <div className="container z-1000">
            <div className="row gx-5 align-items-center">
              <div className="col-lg-12 calendario-head mb-3">
                <p className="mb-0">Calendário {ano}</p>
              </div>      
            </div>
          </div>
        </section>

        <div className="row g-4">
          {Array.isArray(exames) && exames.length > 0 ? (
            exames.map((exame) => (
              <div key={exame.id} className="col-lg-3 col-md-6 mb10">
                <div className="bloglist item">
                  <div className="post-content">
                    <div className="image-calendario">
                      <Link to={`${basePath}/${exame.url}`}>
                        <img src={exame.foto} alt={exame.nome} title={exame.sobre} />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <section>
              <div className="container">
                <div className="row align-items-center gh-5">
                    <div className="col-lg-6 position-relative">
                        <div className="images-deco-1">
                            <img src="./img/misc/treino.png" className="d-img-1" alt=""/>
                            <img src="./img/misc/treino2.png" className="d-img-2" alt=""/>
                            <div className="d-img-3 bg-color"></div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <p >“Em breve novidades!</p>
                    </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    );
}

export default ExamesListar;
